'use client';

import { useInView } from '@/lib/hooks';
import AnimatedNumberSection from '../ui/Numbers';

export default function ProgressBar({ title, percent = 0 }: { title: string; percent: number }) {
    const { isInView, elementRef } = useInView();

    return (
        <div ref={elementRef}>
            <div className="flex justify-between items-center">
                <span className="text-h6 font-medium">{title}</span>
                <AnimatedNumberSection
                    number={percent}
                    className="text-dark-grey opacity-100 text-h6 font-medium"
                    isPercent
                />
            </div>
            <div className="h-1 relative rounded-3 overflow-hidden mt-2">
                <div className="w-full h-full bg-progress-bg absolute"></div>
                <div
                    className="transition-all rounded-3 ease-out duration-2000 delay-100 h-full bg-brand relative"
                    style={{
                        width: isInView ? `${percent}%` : 0,
                    }}
                ></div>
            </div>
        </div>
    );
}
